import { render, staticRenderFns } from "./Unpaid.vue?vue&type=template&id=152ddcbd&"
import script from "./Unpaid.vue?vue&type=script&lang=js&"
export * from "./Unpaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports